/**
 * `crypto.randomUUID` is only defined in a *secure context*, so it is missing
 * when the app is opened over plain http — which is how the dev build gets
 * tested from a phone on the LAN. Calling it there throws before anything
 * reaches the screen, and the message that triggered it disappears without a
 * trace, so every send path takes its id from here instead.
 */
export const randomId = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  // getRandomValues, unlike randomUUID, is available in insecure contexts.
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
    bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10xx
    const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');

    return [
      hex.slice(0, 8),
      hex.slice(8, 12),
      hex.slice(12, 16),
      hex.slice(16, 20),
      hex.slice(20),
    ].join('-');
  }

  return `${Date.now().toString(16)}-${Math.random().toString(16).slice(2, 10)}`;
};
